import { render } from "./EmailSender.vue?vue&type=template&id=c8f6eb1e"
import script from "./EmailSender.vue?vue&type=script&lang=js"
export * from "./EmailSender.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "c8f6eb1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8f6eb1e', script)) {
    api.reload('c8f6eb1e', script)
  }
  
  module.hot.accept("./EmailSender.vue?vue&type=template&id=c8f6eb1e", () => {
    api.rerender('c8f6eb1e', render)
  })

}

script.__file = "src/components/EmailSender.vue"

export default script